/* eslint-disable no-unused-vars,prefer-destructuring */
import { IModel } from '@src/js/separate-logic/interface/IModel';
import _get from 'lodash/get';
import { statusReport007 } from '@src/slide/infrastructure/module/dependent/report/real-time-report/real-time';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';

export default class ShapeElementModel implements IModel {
    public isPlaceHolder: boolean;
    public editorFocus: boolean;
    public setResize: boolean;
    public datetime: Date;
    public initModel(props: any) {
        const component: IShapeModel = props.component;
        this.isPlaceHolder = component?.isPlaceholder;
        this.datetime = _get(component, 'initDatetime');
        this.editorFocus = false;
        this.setResize = false;

        // 以下代码为收集本地附件（是否成组）数据（007上报后续移除）
        const isAttachment = component?.props?.attachment;
        const isGroup = component?.parent?.type === UIModelType.GROUP;
        const slideId = window?.clientVars?.padId;
        if (isAttachment) {
            const tdwParams = {
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.PC_EDIT,
                ver6: slideId,
            };
            if (isGroup && !window.attachmentGroupReported) {
                // 成组且从未上报过的
                window.attachmentGroupReported = true;
                tdw({ ...tdwParams, action: TDWActionType.FILE_GROUP_SHOW });
                statusReport007('slide-attachment-group', 0);
            }
            if (!window.attachmentNormalReported) {
                // 不区分是否分组从未上报过的
                window.attachmentNormalReported = true;
                tdw({ ...tdwParams, action: TDWActionType.FILE_SHOW });
                statusReport007('slide-attachment-all', 0);
            }
        }
    }
}
